
import Axios from "axios";

const base_Url = 'https://digital-products.thesaicomputers.com/v1'

// const base_Url = 'http://localhost:4000'



export async function getOtp(loginForm) {
  const body = {
    Mobile_No: loginForm.mobile_no,
    Android_ID: "9774d56d682e549c"
  };
  try {
    const response = await Axios.post(`${base_Url}/login`, body)
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function formSubmittion(formData) {
  const formatDateIST = (date) => {
    return new Date(date).toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata"
    });
  };
  const formattedDate = formatDateIST(formData?.date);

  const body = {
    name: formData?.bd_person_name?.value,
    mode_of_meeting: formData?.mode_of_meeting?.value,
    client_name: formData?.client_name,
    person_name: formData?.person_name,
    designation: formData?.designation,
    department: formData?.department,
    phone_type: formData?.phone_type?.value,
    phone_no: formData?.phone,
    email: formData?.email,
    summary: formData?.summary,
    next_step: formData?.next_step,
    remark: formData?.remark,
    date: formattedDate,
    type_of_meeting: formData?.type_of_meeting?.value,
  };
  // console.log("bodybody", body);
  try {
    const response = await Axios.post(`${base_Url}/submit-meeting`, body)
    return response?.data;
  } catch (error) {
    return error.response;
  }
}

export async function getBD_Names(token) {
  const config = {
    headers: {
      Authorization: token
    },
  };

  try {
    const response = await Axios.get(`${base_Url}/employees`, config)
    return response?.data;
  } catch (error) {
    return error.response;
  }
}

